(function() {
  var WRAPPER_SELECTOR = '.manual-product-recommendations[data-fixed-height-rows]';
  var GRID_SELECTOR = '.manual-product-recommendations__grid';
  var ITEM_SELECTOR = '.manual-product-recommendations__item';
  var ACTIVE_ATTR = 'data-fixed-height-active';
  var HEIGHT_EVENT = 'tenez:manual-recommendations:height-change';
  var IMAGE_LISTENER_KEY = '__manualFixedHeightImageListener';
  var SCHEDULE_APPLY_KEY = '__manualFixedHeightScheduleApply';
  var RESIZE_OBSERVER_KEY = '__manualFixedHeightResizeObserver';

  function schedule(callback) {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(callback);
    } else {
      setTimeout(callback, 16);
    }
  }

  function toPositiveInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    if (isNaN(parsed) || parsed < 1) {
      return fallback;
    }
    return parsed;
  }

  function collectRows(cards) {
    var rows = [];
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var top = card.offsetTop;
      var bottom = top + card.offsetHeight;
      var matchedRow = null;

      for (var j = 0; j < rows.length; j++) {
        if (Math.abs(rows[j].top - top) < 1) {
          matchedRow = rows[j];
          break;
        }
      }

      if (matchedRow) {
        if (bottom > matchedRow.bottom) {
          matchedRow.bottom = bottom;
        }
      } else {
        rows.push({ top: top, bottom: bottom });
      }
    }

    rows.sort(function(a, b) {
      return a.top - b.top;
    });

    return rows;
  }

  function clearHeight(wrapper, grid, heightValue) {
    if (!grid) return;
    grid.style.removeProperty('height');
    grid.removeAttribute(ACTIVE_ATTR);
    dispatchHeightEvent(grid, heightValue);
  }

  function applyHeight(wrapper) {
    if (!wrapper || !wrapper.isConnected) return;

    var grid = wrapper.querySelector(GRID_SELECTOR);
    if (!grid) return;

    var desiredRows = toPositiveInteger(wrapper.getAttribute('data-fixed-height-rows'), 4);
    var cards = grid.querySelectorAll(ITEM_SELECTOR);

    if (!cards.length || !desiredRows) {
      clearHeight(wrapper, grid);
      return;
    }

    var renderedHeight = grid.getBoundingClientRect().height;
    grid.style.height = 'auto';

    var rows = collectRows(cards);
    if (!rows.length) {
      clearHeight(wrapper, grid);
      return;
    }

    var measuredRows = rows.length;
    if (measuredRows <= desiredRows) {
      clearHeight(wrapper, grid, renderedHeight);
      return;
    }

    var desiredHeight = rows[desiredRows - 1].bottom;

    if (!desiredHeight || desiredHeight <= 0 || !isFinite(desiredHeight)) {
      clearHeight(wrapper, grid);
      return;
    }

    var targetHeight = desiredHeight;
    if (targetHeight < 0 || !isFinite(targetHeight)) {
      clearHeight(wrapper, grid);
      return;
    }

    targetHeight = Math.round(targetHeight);

    if (Math.abs(targetHeight - renderedHeight) < 1 && grid.getAttribute(ACTIVE_ATTR) === 'true') {
      grid.style.height = targetHeight + 'px';
      grid.setAttribute(ACTIVE_ATTR, 'true');
      return;
    }

    grid.style.height = targetHeight + 'px';
    grid.setAttribute(ACTIVE_ATTR, 'true');
    dispatchHeightEvent(grid, targetHeight);
  }

  function initWrapper(wrapper) {
    if (!wrapper || !wrapper.isConnected) return;
    var grid = wrapper.querySelector(GRID_SELECTOR);
    if (!grid) return;
    var cards = grid.querySelectorAll(ITEM_SELECTOR);

    var scheduleApply = wrapper[SCHEDULE_APPLY_KEY];
    if (!scheduleApply) {
      scheduleApply = function() {
        schedule(function() {
          applyHeight(wrapper);
        });
      };
      wrapper[SCHEDULE_APPLY_KEY] = scheduleApply;
    }

    var previousObserver = wrapper[RESIZE_OBSERVER_KEY];
    if (previousObserver && typeof previousObserver.disconnect === 'function') {
      previousObserver.disconnect();
    }
    if (typeof ResizeObserver !== 'undefined' && cards.length) {
      var observer = new ResizeObserver(scheduleApply);
      for (var i = 0; i < cards.length; i++) {
        observer.observe(cards[i]);
      }
      wrapper[RESIZE_OBSERVER_KEY] = observer;
    } else {
      wrapper[RESIZE_OBSERVER_KEY] = null;
    }

    var images = grid.querySelectorAll('img');
    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      var previousListener = image[IMAGE_LISTENER_KEY];
      if (previousListener && previousListener !== scheduleApply) {
        image.removeEventListener('load', previousListener);
        image.removeEventListener('error', previousListener);
      }
      if (previousListener !== scheduleApply) {
        image.addEventListener('load', scheduleApply);
        image.addEventListener('error', scheduleApply);
        image[IMAGE_LISTENER_KEY] = scheduleApply;
      }
    }

    scheduleApply();
  }

  function applyAll() {
    var wrappers = document.querySelectorAll(WRAPPER_SELECTOR);
    for (var i = 0; i < wrappers.length; i++) {
      applyHeight(wrappers[i]);
    }
  }

  function initAll() {
    var wrappers = document.querySelectorAll(WRAPPER_SELECTOR);
    for (var i = 0; i < wrappers.length; i++) {
      initWrapper(wrappers[i]);
    }
    applyAll();
  }

  function onEvent() {
    schedule(initAll);
  }

  function dispatchHeightEvent(grid, explicitHeight) {
    if (!grid || !grid.isConnected) return;

    var detail = {
      height:
        explicitHeight != null && explicitHeight !== false
          ? explicitHeight
          : grid.style.height || '',
      scrollHeight: grid.scrollHeight,
      timestamp: Date.now()
    };

    var event;
    try {
      event = new CustomEvent(HEIGHT_EVENT, { detail: detail });
    } catch (error) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(HEIGHT_EVENT, true, false, detail);
    }

    document.dispatchEvent(event);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onEvent);
  } else {
    schedule(initAll);
  }

  window.addEventListener('load', onEvent);
  window.addEventListener('resize', onEvent);
  document.addEventListener('shopify:section:load', onEvent);
  document.addEventListener('shopify:block:select', onEvent);
  document.addEventListener('shopify:block:deselect', onEvent);
})();
